import { render } from "./SysConfig.vue?vue&type=template&id=2252330d&scoped=true&ts=true"
import script from "./SysConfig.vue?vue&type=script&lang=ts"
export * from "./SysConfig.vue?vue&type=script&lang=ts"

import "./SysConfig.vue?vue&type=style&index=0&id=2252330d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2252330d"]])

export default __exports__